import FondationsServiceModel from '@/models/FondationsServiceModel';

export default class UserRegisterModel extends FondationsServiceModel {
	static get path(): string {
		return '/users/register';
	}
}
